import type { FC } from 'react';


import '../styles/style.css';

const International: FC = () => {

  return (
    <div className='international'>
      <p className='international__caption'>Международное участие</p>
      <h2 className='international__title'>Представьте свои практики на&nbsp;международном семинаре в&nbsp;рамках Транспортной недели&nbsp;2026</h2>
      <p className='international__text'>Транспортная неделя пройдёт в&nbsp;Москве с&nbsp;17&nbsp;по&nbsp;23 ноября. Свои практики представят победители каждой номинации.</p>
    </div>
  );
};

export default International;
